/**
 * Иторум API для портала
 * Спецификация Open API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from "@angular/core";
import {
  HttpClient, HttpHeaders, HttpParams,
  HttpResponse, HttpEvent
} from "@angular/common/http";
import { CustomHttpUrlEncodingCodec } from "../encoder";

import { Observable } from "rxjs";

import { InlineResponse20018 } from "../model/inlineResponse20018";
import { StepIdTimesBody } from "../model/stepIdTimesBody";

import { BASE_PATH, COLLECTION_FORMATS } from "../variables";
import { Configuration } from "../configuration";


@Injectable()
export class StepTimesService {

  protected basePath = "https://dev.itorum-mr.ru";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = "multipart/form-data";
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   * Get step times by step id
   *
   * @param stepId Step id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiStepStepIdTimesGet(stepId: number, observe?: "body", reportProgress?: boolean): Observable<InlineResponse20018>;
  public apiStepStepIdTimesGet(stepId: number, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<InlineResponse20018>>;
  public apiStepStepIdTimesGet(stepId: number, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<InlineResponse20018>>;
  public apiStepStepIdTimesGet(stepId: number, observe: any = "body", reportProgress: boolean = false): Observable<any> {

    if (stepId === null || stepId === undefined) {
      throw new Error("Required parameter stepId was null or undefined when calling apiStepStepIdTimesGet.");
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken = typeof this.configuration.accessToken === "function"
        ? this.configuration.accessToken()
        : this.configuration.accessToken;
      headers = headers.set("Authorization", "Bearer " + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      "application/json"
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<InlineResponse20018>("get", `${this.basePath}/api/step/${encodeURIComponent(String(stepId))}/times`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update step times
   *
   * @param stepId Step control id
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiStepStepIdTimesPut(stepId: number, body?: StepIdTimesBody, observe?: "body", reportProgress?: boolean): Observable<InlineResponse20018>;
  public apiStepStepIdTimesPut(stepId: number, body?: StepIdTimesBody, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<InlineResponse20018>>;
  public apiStepStepIdTimesPut(stepId: number, body?: StepIdTimesBody, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<InlineResponse20018>>;
  public apiStepStepIdTimesPut(stepId: number, body?: StepIdTimesBody, observe: any = "body", reportProgress: boolean = false): Observable<any> {

    if (stepId === null || stepId === undefined) {
      throw new Error("Required parameter stepId was null or undefined when calling apiStepStepIdTimesPut.");
    }


    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken = typeof this.configuration.accessToken === "function"
        ? this.configuration.accessToken()
        : this.configuration.accessToken;
      headers = headers.set("Authorization", "Bearer " + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      "application/json"
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json"
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.request<InlineResponse20018>("put", `${this.basePath}/api/step/${encodeURIComponent(String(stepId))}/times`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

}
